module.exports = __webpack_public_path__ + "img/2.af475426.jpg";